import React from "react";

interface Props {
  to: string;
}
export const Redirect = ({ to }: Props): JSX.Element => {
  window.location.replace(to);
  return <></>;
};
